function Terms(){
    return (
        <div><p>Terms to be Updated</p></div>
        );
}

export default Terms;